<canvas
  [id]="canvasId"
  [ngStyle]="{
    height: size.height + 'px'
  }"
></canvas>
<svg
  #svgContainer
  class="svg-container"
  [ngStyle]="{
    height: size.height + 'px'
  }"
  [class.zooming]="zooming"
>
  <rect
    #rectZoom
    x="0"
    y="0"
    fill="white"
    fill-opacity="0"
    stroke="none"
    class="rect-ui"
    [attr.width]="size.width"
    [attr.height]="size.height"
    [style.cursor]="canvasCursor"
  ></rect>
  <!-- This wrapper applies the transformation from the zoom -->
  <g #shapeWrapper *ngIf="zoomTransformation" [attr.transform]="zoomTransformation">
    <!--  Renders circle of the clusters -->
    <ng-container *ngIf="circlesData && circlesData.children">
      <ng-container *ngFor="let child of circlesData.children">
        <g
          chart-circle-packing-ui
          [class.disable-selection]="disableSelection"
          [class.disable-remove]="disableRemove"
          [circle]="child"
          [modelProperty]="modelProperty || 'id'"
          [active]="activeNode"
          [selectedMap]="selectedMap"
          [actualDepth]="actualDepth"
          [zoom]="zoomTransformation"
          [attr.stroke-width]="STROKE_CIRCLE_UI / zoomTransformation.k < STROKE_CIRCLE_UI_IDEAL ? STROKE_CIRCLE_UI_IDEAL : STROKE_CIRCLE_UI"
          (hover)="onHover($event)"
          (zoomIn)="zoomIn($event, true)"
          (select)="selected($event)"
          (remove)="remove.emit($event)"
        ></g>
      </ng-container>
    </ng-container>
  </g>
</svg>

<!-- ZOOM CONTROLS -->
<chart-zoom-controls
  *ngIf="controlConfig"
  [padding]="canvasPadding"
  [zoom]="controlConfig.zoom"
  [svgContainer]="controlConfig.svgContainer"
  [rectZoom]="controlConfig.rectZoom"
  [shapeWrapper]="controlConfig.shapeWrapper"
  [enableZoomScroll]="enableZoomScroll"
  (trackEvent)="trackEvent.emit($event)"
></chart-zoom-controls>

<!-- ACTIVE NODE! -->
<div *ngIf="activeNode" class="breadcrumb">
  <ui2-button [title]="'chart-ng-circle-packing.backButton' | translate" class="button-icon" (clicked)="zoomBack()">
    <span class="icon icon2-x16-back"></span>
  </ui2-button>

  <div class="label-base">{{ activeNode.label | titleCase }}</div>
</div>

<div class="options">
  <div *ngIf="actualSelectModel && actualSelectModel.length" class="option-button" (click)="deselectAll()">
    {{ 'chart-ng-circle-packing.deselectAll' | translate }}
  </div>
</div>

<div *ngIf="noData" class="placeholder-no-input-data">
  {{ 'chart-ng-circle-packing.noData' | translate }}
</div>
